import { FormSubmission } from '@wix/ambassador-forms-v4-submission/types';
import { FormValues, FormOverrides } from '@wix/form-viewer';
import { WixFormFields } from '../types/wix-forms';
import {
  IntakeForms,
  IntakeFormStatus,
  WixFormsFieldProperties,
} from './state/types';

export function getEmailFromSubmission(
  submission?: FormSubmission,
): string | undefined {
  if (!submission?.submissions) {
    return undefined;
  }

  const submissionData = submission.submissions;

  const emailValue = submissionData[WixFormFields.EMAIL];

  return typeof emailValue === 'string' ? emailValue : undefined;
}

export function hasEmailMismatchWithIntakeForms(
  email: string | undefined,
  intakeForms?: IntakeForms,
): boolean {
  if (!email || !intakeForms) {
    return false;
  }

  const normalizedEmail = email.toLowerCase().trim();

  for (const formId in intakeForms) {
    const intakeForm = intakeForms[formId];

    if (
      intakeForm?.formData &&
      intakeForm?.status === IntakeFormStatus.COMPLETED
    ) {
      const submissionEmail = getEmailFromSubmission(intakeForm.formData);

      if (submissionEmail) {
        const normalizedSubmissionEmail = submissionEmail.toLowerCase().trim();

        if (normalizedEmail !== normalizedSubmissionEmail) {
          return true;
        }
      }
    }
  }

  return false;
}

export function getReadOnlyFieldsOverrides(
  values: FormValues,
  fieldProperties?: WixFormsFieldProperties,
): FormOverrides {
  const overrides: FormOverrides = {};

  overrides[WixFormFields.EMAIL] = {
    readOnly: true,
  };

  if (values[WixFormFields.PHONE] !== undefined) {
    const isPhoneRequired =
      fieldProperties?.[WixFormFields.PHONE]?.required === true;

    if (isPhoneRequired) {
      overrides[WixFormFields.PHONE] = {
        readOnly: true,
      };
    }
  }

  return overrides;
}
